import { Card, Col } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import { useClientContext } from "../../../hooks/ClientContext";
import useOpenMasterAccount from "../../../hooks/useOpenMasterAccount";
import { ThemedSpan } from "../../../components/utilities";
import useMasterAccountDetails from "../../clientdetails/hooks/useMasterAccountDetails";

function NotesSummaryDetails() {
    const { id: masterAccountId } = useClientContext();
    const { data, error, isLoading } = useMasterAccountDetails(masterAccountId);
    const openMasterAccount = useOpenMasterAccount();

    if (isLoading) return (
        <Skeleton height={200} />
    )

    if (error) return <p>Error loading data</p>;
    if (!data) {
        return null;
    }

    const handleOpenClientDetails = (e) => {
        e.preventDefault();
        openMasterAccount(masterAccountId, { suffix: "details" });
    };

    return (
        <>
            <Col className="col-12">
                {data.notes && data.notes.length > 0 && (
                    <div>
                        <Card style={{ height: "auto" }}>
                            <Card.Body>
                                <Card.Title style={{ fontSize: "18px", paddingBottom: "20px" }}><a className="text-reset text-decoration-none" href={`/client/${masterAccountId}/details`}
                                    onClick={(e) => handleOpenClientDetails(e)}>
                                    <ThemedSpan variant="primary" className="fw-bold">Notes</ThemedSpan>
                                </a>
                                </Card.Title>
                                <Card.Text as="div">
                                    <p>{data.notes}</p>
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </div>
                )}
            </Col>
        </>
    )
}

export default NotesSummaryDetails;